import { useEffect, useState } from "react";

const listeners = new Map();
let observer;

const observe = (element, listener) => {
  if (typeof IntersectionObserver === "undefined") return () => {};
  if (!observer) observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => listeners.get(entry.target)?.(entry.isIntersecting));
  }, { rootMargin: "160px" });
  listeners.set(element, listener);
  observer.observe(element);
  return () => {
    observer.unobserve(element);
    listeners.delete(element);
    if (!listeners.size) {
      observer.disconnect();
      observer = undefined;
    }
  };
};

// Keep the existing fixed thumbnail in the document; only its expensive preview
// is deferred. Tracking exits also releases component-held image strings.
export default function usePreviewViewport(enabled) {
  const [element, setElement] = useState(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!enabled || typeof IntersectionObserver === "undefined") {
      setVisible(false);
      return undefined;
    }
    if (!element) return undefined;
    setVisible(false);
    return observe(element, setVisible);
  }, [enabled, element]);
  return [setElement, !enabled || typeof IntersectionObserver === "undefined" || visible];
}
